import React, {useRef} from 'react';

// HOOKS
import useCarousel from '../../../../../../../shared/hooks/useCarousel';

//Styles
import * as S from './DiningCarousel.styles';

const DiningCarousel = ({images}) => {
  const {dataList, increment, decrement, isLeftCursorActive, isRightCursorActive} = useCarousel(
    images,
    1,
  );

  return (
    <S.MainGalleryOuterWrapDiv>
      <S.CarouselImagesWrapper>
        {dataList.map((roomImageSrc, i) => (
          <S.HotelMainGalleryImage src={roomImageSrc} alt={`Room Image ${i}`} key={roomImageSrc} />
        ))}
      </S.CarouselImagesWrapper>

      {!!isLeftCursorActive && (
        <S.LeftArrowOuterWrapper onClick={decrement}>
          <S.LeftArrow></S.LeftArrow>
        </S.LeftArrowOuterWrapper>
      )}

      {!!isRightCursorActive && (
        <S.RightArrowOuterWrapper onClick={increment}>
          <S.RightArrow></S.RightArrow>
        </S.RightArrowOuterWrapper>
      )}
    </S.MainGalleryOuterWrapDiv>
  );
};

export default DiningCarousel;
